import { Space, Skeleton } from '@ag1/ui';
import styles from './TabletSkeleton.module.scss';

const ProductSkeleton = () => (
  <Space className={styles.product}>
    <Skeleton className={styles.image} variant="dark" />
    <Skeleton className={styles.infoContainer} height={274}>
      <Space top={24} bottom={24}>
        <Space bottom={4}>
          <Skeleton height={28} variant="dark" />
        </Space>
        <Space bottom={16}>
          <Skeleton height={48} variant="dark" />
        </Space>
        <Space bottom={16}>
          <Skeleton height={56} variant="dark" />
        </Space>
        <Space>
          <Space bottom={8}>
            <Skeleton height={18} variant="dark" />
          </Space>
          <Space className={styles.flavorsContainer}>
            <Skeleton height={26} width={26} variant="dark" />
            <Skeleton height={26} width={26} variant="dark" />
            <Skeleton height={26} width={26} variant="dark" />
            <Skeleton height={26} width={26} variant="dark" />
          </Space>
        </Space>
      </Space>
    </Skeleton>
  </Space>
);

export const TabletSkeleton = () => (
  <div className={styles.tabletContainer}>
    <Space bottom={8}>
      <Skeleton height={56} variant="dark" />
    </Space>
    <Space bottom={40}>
      <Skeleton height={28} variant="dark" />
    </Space>
    <Space className={styles.productsContainer}>
      <ProductSkeleton />
      <ProductSkeleton />
      <ProductSkeleton />
      <ProductSkeleton />
      <ProductSkeleton />
      <ProductSkeleton />
    </Space>
  </div>
);
